<template>
  <div id="app">
    <router-link to="/login"></router-link>
    <router-view />
  </div>
</template>

<script>
import apiProxy from './apis/api-proxy-inst';
import authInfoMgmt from './auth-info-mgmt-inst';

export default {
  name: 'app',
  components: {},
  data() {
    return {};
  },
  mounted() {
    const that = this;
    authInfoMgmt.init().then(() => {
      if (authInfoMgmt.isSignedIn()) {
        that.$router.push({ path: that.$router.path });
      } else {
        that.$router.push({ name: 'Login' });
      }
      apiProxy.listenAuthException(that.onAuthException);
      apiProxy.listenUnknownException(that.UnknownException);
    });
  },
  beforeDestroy() {
    apiProxy.stopAuthException(this.onAuthException);
  },
  methods: {
    onAuthException() {
      authInfoMgmt.signOut();
      this.$router.push({ name: 'Login' });
      // this.$message('Unauthorized or expired, please sign in again.');
      this.$message({
        message: this.$t('please_sign_in_again'),
        type: 'warning',
        duration: 5000,
        offset: 80
      });
    }
  }
};
</script>

<style lang="scss">
@import '~../../common/style/app';
@import '~../../common/style/elementui';
@import '~../../common/style/common-icon';

#app {
  @include app;
}
</style>
